import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardIconContent.css";
import { Heading } from "~/components/elements/Heading";
import { Icons, type IconValue } from "~/components/elements/Icons";
import clsx from "clsx";
import { Paragraph } from "~/components/elements/Paragraph";

export type CardIconContentProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: {
      title?: string;
      text?: string;
      icon?: IconValue | string | null;
    };
  };

export const CardIconContent = ({
  card,
  className,
  ...props
}: CardIconContentProps) => {
  const { title, text, icon } = card;
  return (
    <div className={clsx(className, styles.card)} {...props}>
      <div className={styles.contentWrapper}>
        {icon && (
          <div className={styles.iconWrapper}>
            <Icons value={icon} size={40} />
          </div>
        )}
        <div className={styles.textContent}>
          {title && (
            <Heading as="h4" size="h4">
              {title}
            </Heading>
          )}

          {text && <Paragraph size="sm">{text}</Paragraph>}
        </div>
      </div>
    </div>
  );
};
